import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getRoute } from 'Config';
import useNavigate from 'Hooks/useNavigate';

import { getIsDeviceFlaggedForDobViolation } from 'Store/app/selectors';
import { openModal } from 'Store/modals/actions';
import { MODAL_AGE_GATE } from 'Store/modals/constants';
import type { CloseModal } from 'Store/modals/types';

type PayloadType = {
  handleCloseModal?: CloseModal;
};

const useAgeGate = ({ handleCloseModal }: PayloadType = {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const deviceFlaggedForDobViolation = useSelector(getIsDeviceFlaggedForDobViolation);
  const defaultCloseModalHandler = useCallback(() => {
    navigate(getRoute('login', { pathConfig: { withPrefix: false } }));
  }, [navigate]);
  const handler = handleCloseModal || defaultCloseModalHandler;

  useEffect(() => {
    if (deviceFlaggedForDobViolation) {
      dispatch(
        openModal(MODAL_AGE_GATE, {
          props: {
            handleCloseModal: handler,
          },
        })
      );
    }
  }, [dispatch, deviceFlaggedForDobViolation, handleCloseModal, handler]);

  return {
    deviceFlaggedForDobViolation,
  };
};

export default useAgeGate;
